/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["one","other","two"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    const v = decimalPart.length;
    if (isOrdinal) {
    }
    else {
        if (i === 1 && v === 0 || i === 0 && v !== 0)
            return "one";
        if (i === 2 && v === 0)
            return "two";
    }
    return "other";
},"pluralRanges":{"cardinal":{"one_other":"other","one_two":"other","other_one":"other","other_other":"other","other_two":"other","two_other":"other"},"ordinal":{}}},"locale":"he"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["one","other","two"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    const v = decimalPart.length;
    if (isOrdinal) {
    }
    else {
        if (i === 1 && v === 0 || i === 0 && v !== 0)
            return "one";
        if (i === 2 && v === 0)
            return "two";
    }
    return "other";
},"pluralRanges":{"cardinal":{"one_other":"other","one_two":"other","other_one":"other","other_other":"other","other_two":"other","two_other":"other"},"ordinal":{}}},"locale":"he"})
}
